// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__21i6W","title":"ClientCherryInfo_title__11I2j","itemText":"ClientCherryInfo_itemText__251-l"};